import { useState } from 'react';

import { BenefitStoreItem, useListCampaignBenefits } from '@givebacks/api/store';
import { ButtonMantine, Center, Modal, ModalProps, SimpleGrid } from 'ui';

import { BenefitDetailsModalCard } from '../BenefitCard';

interface BenefitListModalProps extends ModalProps {
  opened: boolean;
  onClose: () => void;
  campaignId?: string;
  causeId?: string;
  header?: React.ReactNode;
}

const BenefitList = ({
  benefits,
  campaignId,
}: {
  benefits: BenefitStoreItem[];
  campaignId?: string;
}) => {
  return (
    <SimpleGrid cols={{ base: 1, xs: 2 }} pt="xs" spacing="lg">
      {benefits.map((benefit) => (
        <BenefitDetailsModalCard
          key={benefit.uuid}
          title={benefit.name}
          description={benefit.content.description}
          price={benefit.price}
          storeId={benefit.cause_id}
          storeItemId={benefit.uuid}
          image={benefit.images?.[0]?.url}
          campaignId={campaignId}
        />
      ))}
    </SimpleGrid>
  );
};

const BenefitsListModal = ({
  opened,
  onClose,
  campaignId,
  causeId,
  header,
}: BenefitListModalProps) => {
  const { data: benefits } = useListCampaignBenefits({
    campaignId: campaignId,
    causeId: causeId,
    queryOptions: {
      searches: {
        deleted: { value: false },
      },
    },
  });

  if (!benefits) return null;

  return (
    <Modal opened={opened} onClose={onClose} title={header}>
      <BenefitList benefits={benefits.store_items} campaignId={campaignId} />
    </Modal>
  );
};

const BenefitsListModalButton = ({
  campaignId,
  causeId,
  benefitsTitle,
}: {
  campaignId: string;
  causeId: string;
  benefitsTitle: string;
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <Center w="100%">
        <ButtonMantine size="sm" w={122} onClick={() => setIsModalOpen(true)}>
          View All
        </ButtonMantine>
      </Center>
      <BenefitsListModal
        opened={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        campaignId={campaignId}
        causeId={causeId}
        header={benefitsTitle}
      />
    </>
  );
};

export { BenefitsListModal, BenefitsListModalButton };
